import maskHelper from './maskHelper'

export default {
  bind(el, binding, vnode) {
    let input = el.querySelector('input')
    if (input && !input.hasAttribute('readonly')) {
  
       let settings = Object.assign({
       /*  thousands:"", */
        allowZero:true,
        precision: 2
      }, binding.value)
      maskHelper(input, settings)
    }
  }
}
